const SUBSCRIPTION_TAG_STYLE_MAP = Object.freeze({
  premium: Object.freeze({
    background: 'linear-gradient(135deg, #fde68a 0%, #f59e0b 100%)',
    color: '#ffffff',
    border: '0px !important',
  }),
  standard: Object.freeze({
    background: 'linear-gradient(135deg, #e7c3a6 0%, #b87c4c 100%)',
    color: '#ffffff',
    border: '0px !important',
  }),
  privilege: Object.freeze({
    background: 'linear-gradient(135deg, #bbc0c5 0%, #93a0b1 100%)',
    color: '#ffffff',
    border: '0px !important',
  }),
});

export function getSubscriptionTagStyle(subscriptionType) {
  if (typeof subscriptionType !== 'string') return null;
  return SUBSCRIPTION_TAG_STYLE_MAP[subscriptionType.toLowerCase()] || null;
}
